export const allSlotGamesTextContent = {
  btnText: "View More",
  allSlotGamesContent: [
    {
      gameImageSrc: "/assets/stock-img/slot_game_img_01.webp",
      gameNameText: "Jungle Rave",
    },
    {
      gameImageSrc: "/assets/stock-img/slot_game_img_02.webp",
      gameNameText: "Feral Quest",
    },
    {
      gameImageSrc: "/assets/stock-img/slot_game_img_03.webp",
      gameNameText: "Santa Downfall",
    },
    {
      gameImageSrc: "/assets/stock-img/slot_game_img_04.webp",
      gameNameText: "Jewels of Wizard",
    },
    {
      gameImageSrc: "/assets/stock-img/slot_game_img_05.webp",
      gameNameText: "Dino Dynasty",
    },
    {
      gameImageSrc: "/assets/stock-img/slot_game_img_06.webp",
      gameNameText: "Wonderland Grove",
    },
    {
      gameImageSrc: "/assets/stock-img/slot_game_img_07.webp",
      gameNameText: "Bandit Hunter",
    },
    {
      gameImageSrc: "/assets/stock-img/slot_game_img_08.webp",
      gameNameText: "Seek n Catch",
    },
    {
      gameImageSrc: "/assets/stock-img/slot_game_img_09.webp",
      gameNameText: "Shadow of Sabbah",
    },
    {
      gameImageSrc: "/assets/stock-img/slot_game_img_10.webp",
      gameNameText: "Drunkey Monkey",
    },
    {
      gameImageSrc: "/assets/stock-img/slot_game_img_11.webp",
      gameNameText: "Cosmic Crazies",
    },
    {
      gameImageSrc: "/assets/stock-img/slot_game_img_12.webp",
      gameNameText: "Vampires Lair",
    },
  ],
  gamesFilterContent: [
    { filterNavText: "All" },
    { filterNavText: "New Game" },
    // { filterNavText: "Top Ranked" },
    // { filterNavText: "Trending" },
    // { filterNavText: "Popular" },
    // { filterNavText: "Megaway’s Slot" },
  ]
};
